import { useTranslation } from "react-i18next";

import { TYRE_LOCATIONS } from "models";
import { TyreTable } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/TyreQuestionResults/components";
import "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components/TyreQuestionResults/TyreQuestionResults.scss";
import { isInStorageTyre } from "modules/AppointmentDetails/utils";

import type { Appointment, ChecklistTemplate } from "models";
import type { SortedQuestionResult } from "modules/AppointmentDetails/hooks";

type TyreQuestionResultsProps = {
  appointment: Appointment;
  questionResults: SortedQuestionResult[];
  readOnly?: boolean;
  template?: ChecklistTemplate | null;
};

export const TyreQuestionResults = ({ questionResults, template, appointment, readOnly }: TyreQuestionResultsProps) => {
  const { t } = useTranslation();

  let title = t("v8_on_car", "On Car").toUpperCase();
  let icon = "car mirrors";
  if (!appointment.car?.is_truck && (questionResults.at(0)?.truck_axle ?? 0) > 0) {
    title = t("v8_on_vehicle", "On Vehicle").toUpperCase();
    icon = "truck";
  } else if (appointment.car?.is_truck) {
    title = t("v8_on_truck", "On Truck").toUpperCase();
    icon = "truck";
  }

  const vehicleQuestionResults: SortedQuestionResult[] = [];
  const storageQuestionResults: SortedQuestionResult[] = [];
  questionResults.forEach(questionResult =>
    isInStorageTyre(questionResult.tyre_position) ? storageQuestionResults.push(questionResult) : vehicleQuestionResults.push(questionResult)
  );

  return (
    <div className="TyreQuestionResults">
      {(!readOnly || vehicleQuestionResults.length > 0) && (
        <TyreTable
          icon={icon}
          title={title}
          questionResults={vehicleQuestionResults}
          template={template}
          appointment={appointment}
          tyreLocation={TYRE_LOCATIONS.OnVehicle}
          readOnly={readOnly}
        />
      )}
      {storageQuestionResults.length > 0 && (
        <TyreTable
          icon="garage"
          title={t("v8_in_storage", "In Storage").toUpperCase()}
          questionResults={storageQuestionResults}
          template={template}
          appointment={appointment}
          tyreLocation={TYRE_LOCATIONS.InStorage}
          readOnly={readOnly}
        />
      )}
    </div>
  );
};
